import { Link } from "react-router-dom";
import { BRAND_LOGO } from "../lib/api";

export default function Footer() {
  return (
    <footer className="bg-[#121212] text-white mt-20" data-testid="site-footer">
      <div className="h-1 apa-stripe-accent" />
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-16 grid md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={BRAND_LOGO} alt="" className="h-14 w-14 object-contain" />
            <div>
              <div className="font-display font-extrabold text-lg">AUTO PARTS</div>
              <div className="font-display font-extrabold text-lg text-[#FFD100]">AFRICA</div>
            </div>
          </div>
          <p className="text-sm text-zinc-400 max-w-sm leading-relaxed">
            A continent-wide auto parts marketplace. Source globally, verified locally, delivered anywhere in Africa.
          </p>
        </div>
        <div>
          <div className="font-display font-bold uppercase text-xs tracking-widest text-[#FFD100] mb-4">Shop</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/search" className="hover:text-white">All parts</Link></li>
            <li><Link to="/search?category=Engine" className="hover:text-white">Engine</Link></li>
            <li><Link to="/search?category=Brakes" className="hover:text-white">Brakes</Link></li>
            <li><Link to="/search?category=Electrical" className="hover:text-white">Electrical</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-display font-bold uppercase text-xs tracking-widest text-[#FFD100] mb-4">Platform</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/register" className="hover:text-white">Become a seller</Link></li>
            <li><Link to="/register" className="hover:text-white">Join as agent</Link></li>
            <li><Link to="/how-it-works" className="hover:text-white">How it works</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-display font-bold uppercase text-xs tracking-widest text-[#FFD100] mb-4">Support</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li>Mon–Sat, 8am–6pm EAT</li>
            <li>support@autopartsafrica.com</li>
            <li>Nairobi · Lagos · Accra</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-zinc-400">
          <div>© {new Date().getFullYear()} Auto Parts Africa. Built on the continent, for the continent.</div>
          <div className="flex gap-4">
            <span>Global sourcing</span>
            <span>·</span>
            <span>Agent verified</span>
            <span>·</span>
            <span>Air &amp; sea freight</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
